import { lazy } from "react";

export { DYNAMIC_PROCESSES_LIST_PATH } from "./dynamic-processes-list-path";
export const DynamicProcessesListPage = lazy(
  () => import("./dynamic-processes-list"),
);
